webpackJsonp([2888652111644],{

/***/ 389:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>WIP: This page will describe how to install the Progressive Web Apps for the platforms that support them, giving the most native-like user experience.</p>","frontmatter":{"path":"/SF2PWA","title":"Progressive Web App Features","summary":"How to install the SubFire PWAs"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---sf-2-pwa-d14b52f1dbb0f9875e20.js